export default __webpack_public_path__ + "static/media/search.90a81624.png";